import { Skeleton as Skel } from "@material-ui/lab";
import PermissionsSkeleton from "../../PermissionChecklist/Skeleton";
import { Grid } from '@material-ui/core';

import { useTranslation } from "react-i18next";

import TitledContainer from '../../../../ui/TitledContainer';

const Skeleton = () => {

    const { t } = useTranslation();

    return (
        <div>
            <Grid item xs={12} style={{ position: "relative", padding: "1rem" }} >
                <TitledContainer
                    title={t("userManagement.emailInput.title")}
                >
                    <Skel style={{margin: "20px"}} />    
                </TitledContainer>
            </Grid>
            <PermissionsSkeleton />
        </div>
    )
}

export default Skeleton;